import { Data } from '../../../database.schema';
import { useFetchData } from '../tournament-data';

export const useFetchTournaments = () => {
  return useFetchData((data: Data) => {
    return data.tournaments.map((tournament, index) => {
      return {
        year: tournament.year,
        index,
        type: tournament.type,
        state: tournament.state,
      };
    });
  });
};
